import * as React from "react";
import { forwardRef } from "react";
const SvgChecked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 11, viewBox: "0 0 13 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 5.73684L4.85714 10L11.5 1.5", stroke: "currentColor", strokeWidth: 2, strokeLinejoin: "bevel" }));
const ForwardRef = forwardRef(SvgChecked);
export { ForwardRef as ReactComponent };
